import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { label: String }

  track() {
    if (window.ahoy) {
      ahoy.track("outbound_click", {
        label: this.labelValue,
        url: this.element.href
      })
    }
  }
}
